import Map from 'scripts/models/base/map';

export default Map.extend({
    define: {
        type: {
            type: 'string',
            value: 'cloudinary'
        },
        identifier: {
            type: 'string',
            value: ''
        },
        gravity: {
            type: 'string',
            /**
             * Holds one value from the list: north_west|north|north_east|west|center|east|south_west|south|
             * south_east|face|faces
             */
            value: ''
        },
        'crop-mode': {
            type: 'string',
            /**
             * Holds one value from the list: scale|fill|lfill|fit|mfit|limit|pad|lpad|mpad|crop|thumb
             */
            value: ''
        }
    }
});
